module.exports = __webpack_public_path__ + "static/moonamar-hladno-cijedeno-bundevino-bucino-ulje-ad499326d6e8338b92b693ad1d4742aa.png";